import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import Select from 'src/shared/components/select/Select';

const CommunityWriteForms = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex flex-col justify-between gap-20 p-20">{children}</div>
  );
};

const Categories = ({
  registerName,
  options,
  tag
}: {
  registerName: string;
  tag?: string | null;
  options: Array<{ label: string; value: string }>;
}) => {
  const { setValue } = useFormContext();
  return (
    <div className="flex flex-col gap-8">
      <Select
        selectContainerStyle={{ height: '53px' }}
        width={'100%'}
        defaultValue={tag ? tag : '카테고리 선택'}
        options={options}
        onChange={value => {
          setValue(registerName, value);
        }}
      />
    </div>
  );
};

const TitleInput = ({
  registerName,
  placeholder
}: {
  registerName: string;
  placeholder: string;
}) => {
  const { register } = useFormContext();
  return (
    <input
      {...register(registerName)}
      className="w-full bg-transparent pb-12 text-16 h-53 placeholder:text-[#5C576B] border-b border-solid border-[#2E2B36]"
      placeholder={placeholder}
    />
  );
};

CommunityWriteForms.Categories = Categories;
CommunityWriteForms.Title = TitleInput;

export default CommunityWriteForms;
